module.exports = __webpack_public_path__ + "static/media/cash-for-junk-car-sunnybank.6bf59ed4.png";